import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../components/header/boardHeader";
import Avatar from "@mui/material/Avatar";

function AddProspects() {
    const navigate = useNavigate();

    const toUpload = () =>{
        navigate("/fileUpload");
    }

    const toProfile = () =>{
        navigate("/addCandidates");
    }

  
    return (
        <div className="w-full min-h-screen bg-blue-7">
            <div className="sticky top-0 z-50">
                <Header current="home" />
            </div>       

            <div className="flex justify-center">
                
                <div className="w-[370px] md:w-[700px] bg-white-1 mt-10 rounded-lg mx-5 md:mx-0 md:py-4">

                    <div className="px-5 md:px-24 py-12">
                        <div><Avatar src="prospect1.svg" sx={{ width: 84, height: 86 }} /></div>

                            <div className="grid grid-cols-12 gap-3 mt-6">
                                {/* Add text */}
                                <div className="text-[24px] md:text-[32px] font-bold col-span-12">How would you like to add a new prospect?</div>

                                {/* Add text */}
                                <div className="mt-3 text-[18px] md:text-[20px] font-medium col-span-12">Creating prospects in allows you to connect with your leads more efficiently.</div>

                                <div className="md:mt-10 mt-16 omd-1:mb-20 col-span-12 flex justify-between">
                                    {/* First div */}
                                    <div className="" >
                                        <div className="w-3 h-3 rounded-full bg-blue-7 mx-[45%]"></div>
                                        <div className="text-[11px] font-normal md:text-[18px] mt-2 md:mx-[5%]">Bulk import candidates</div>
                                        <button onClick={() => toUpload()}   className="mt-4 flex bg-pink-1 h-9 md:h-12 text-[12px] md:text-[17.09px] font-semibold text-white-1 md:mt-2 px-4 md:px-6 rounded flex items-center">Upload a CSV file <img className="hidden md:block ml-1.5 md:ml-4" src="arrownext.svg"/> </button> 
                                    </div>
                                    {/* Second div */}
                                    <div className="">
                                        <div className="w-3 h-3 rounded-full bg-blue-7 mx-[45%]"></div>
                                        <div className="text-[11px] font-normal md:text-[18px] mt-2 md:mx-[5%]">Add a single prospect</div>
                                        <button  onClick={() => toProfile()}  className="mt-4 flex bg-blue-1 h-9 md:h-12 text-[12px] md:text-[17.09px] font-semibold text-white-1 md:mt-2 px-4 md:px-6  rounded flex items-center">Create a profile <img className="hidden md:block ml-1.5 md:ml-4" src="arrownext.svg"/> </button> 
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default AddProspects;
